/** @module Enums */ /** typedoc */

export enum AccountGlobalStatusEnum {
    /**
     * AccountingStatus == 'Good' && ServiceStatus == 'Active'
     */
    Active = 'Active',
    /**
     * AccountingStatus == ('PoorStanding' | 'Collections') && ServiceStatus == 'Active'
     */
    PoorStanding = 'PoorStanding',
    /**
     * AccountingStatus = * && (ServiceStatus == 'Suspended' | 'Hold')
     */
    Suspended = 'Suspended'
}
